/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The current state of the visit from the perspective of the patient.
 */
export type UniversalClinicVisitStatus =
  (typeof UniversalClinicVisitStatus)[keyof typeof UniversalClinicVisitStatus];

export const UniversalClinicVisitStatus = {
  pending: "pending",
  "in-progress": "in-progress",
  completed: "completed",
  incomplete: "incomplete",
  cancelled: "cancelled",
} as const;
